module.exports = __webpack_public_path__ + "img/swift-checkin-ezybuild-logo.f66a6a49.png";